import { BaseQueryFn, createApi } from "@reduxjs/toolkit/query/react";
import { createContext, useContext } from "react";

export function createLightSandboxApi(baseQuery: BaseQueryFn) {
  return createApi({
    reducerPath: "lightSandboxApi",
    baseQuery,
    tagTypes: ["Account", "BillingAddress", "PaymentMethod"],
    endpoints: (builder) => ({
      seedDemoData: builder.mutation<void, void>({
        query: () => ({
          url: "sandbox/seed-demo-data",
          method: "POST",
        }),
      }),
      deleteDemoData: builder.mutation<void, void>({
        query: () => ({
          url: "sandbox/delete-demo-data",
          method: "POST",
        }),
      }),
      deleteEnrollment: builder.mutation<void, void>({
        query: () => ({
          url: "sandbox/delete-enrollment",
          method: "POST",
        }),
      }),
    }),
  });
}

export type LightSandboxApi = ReturnType<typeof createLightSandboxApi>;

export const LightSandboxContext = createContext<LightSandboxApi | null>(null);

export function useLightSandbox(): LightSandboxApi {
  const lightSandbox = useContext(LightSandboxContext);
  if (!lightSandbox) {
    throw new Error(
      "useLightSandbox must be used inside a LightSandboxContext.Provider",
    );
  }
  return lightSandbox;
}
